/*
 * @Description:系统公用接口
 * @Author: miaomiao
 * @Date: 2021-03-17 15:07:40
 * @LastEditTime: 2023-11-28 14:18:43
 * @LastEditors: zerui.yao
 */

import db from '@/api/db';
import dbGateway from '@/api/dbGateway';

const model = {
  // 获取数据字典
  getDictionarySources(param) {
    return db.get('/sys/dictionary/getSysName', param);
  },
  // 选人组件
  getListByNameOrDept(params) {
    return db.post('/umd/user/listByNameLike', params);
  },
  // 获取文件预览地址
  getFileViewUrl(params) {
    return dbGateway.post('/magic-box/common/file/view', params);
  },
  // 获取文件数据流
  getFileDownloadUrl(params) {
    return dbGateway.get('/magic-box/common/file/get', params, {
      responseType: 'blob',
    });
  },
};
export default model;
